import { create } from "zustand";

export const useImageHeightStore = create((set) => ({
  imageHeights: {},
  setImageHeight: (key, height) =>
    set((state) => ({
      imageHeights: { ...state.imageHeights, [key]: height },
    })),
}));
